export default "__VITE_ASSET__KZwCMx58__"